import React, { FC, memo } from "react";

const ClientInfoCard: FC<{
  name: string;
  email?: string;
  option: string;
  message?: string;
  date?:string;
}> = memo(({ name, email, option, message,date }) => {
  return (
    <tbody className="divide-y divide-gray-200 bg-gray-100">
      <tr>
        <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
          {name}
        </td>
        <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
          {email}
        </td>
        <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
          {option}
        </td>
        <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
          {message}
        </td>
        <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
          {date}
        </td>
      </tr>
    </tbody>
  );
});

export default ClientInfoCard;
